import { apiProxyRequest as request } from "Api/apiProxyRequest";

export const deleteOrganizationProject = async (
  organizationId: string,
  projectId: string
) =>
  await request<void>(
    `/organizations/${organizationId}/projects/${projectId}`,
    "DELETE"
  );
